import { ViewToggle } from './controls/ViewToggle';
import { CopilotToggle } from './controls/CopilotToggle';
import { LicenseMatrix } from './matrix/LicenseMatrix';
import { LicenseVisualizer } from './visualizer/LicenseVisualizer';
import { CategorySelector } from './controls/CategorySelector';
import { PricingPeriodToggle } from './controls/PricingPeriodToggle';
import { useLicenseConfiguration } from '../hooks/useLicenseConfiguration';
import { LICENSE_CATEGORIES } from '../constants/licenseCategories';
import { usePricing } from '../contexts/PricingContext';

export const LicenseConfigurator = () => {
  const {
    selectedCategory,
    setSelectedCategory,
    view,
    setView,
    copilotEnabled,
    setCopilotEnabled,
    getCategoryPlans,
    handlePrint
  } = useLicenseConfiguration();

  const { period, setPeriod, announcedDate, hasPreRenewal } = usePricing();

  const plans = getCategoryPlans(selectedCategory);

  return (
    <div className="bg-white rounded-lg shadow-lg">
      <div className="p-6 border-b border-gray-200">
        <CategorySelector
          categories={LICENSE_CATEGORIES}
          selectedCategory={selectedCategory}
          onCategoryChange={setSelectedCategory}
        />

        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between mt-4">
          <ViewToggle
            view={view}
            onViewChange={setView}
            onPrint={handlePrint}
          />

          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <PricingPeriodToggle
              period={period}
              onPeriodChange={setPeriod}
              announcedDate={announcedDate}
              hasPreRenewal={hasPreRenewal}
            />

            <CopilotToggle
              enabled={copilotEnabled}
              onChange={setCopilotEnabled}
              category={selectedCategory}
            />
          </div>
        </div>
      </div>

      <div className="p-6">
        {plans && plans.length > 0 ? (
          view === 'matrix' ? (
            <LicenseMatrix plans={plans} />
          ) : (
            <LicenseVisualizer plans={plans} />
          )
        ) : (
          <div className="text-center py-8 text-gray-500">
            No plans available for this category
          </div>
        )}
      </div>
    </div>
  );
};